
// 公司列表itemVo
export interface CompanyItemVo {
    pkid?: string; // id
    contactName: string; // 中文名称
    englishName: string; // 拼音或英文名称
    address: string; // 地址
    contactWay: string; // 电话
}


// 公告itemVo
export interface NoticeItemVo {
    content: string;    // 内容，html字符串
    overview: string;   // 描述
    publishDate: string;    // 发布日期
    publisher: string;  // 发布者
    title: string;  // 标题
}


// 公司数据默认state
export const COMPANY_INIT_STATE: CompanyItemVo = {
    pkid: null,
    contactName: null,
    englishName: null,
    address: null,
    contactWay: null,
}

// 公告默认数据state
export const NOTICE_INIT_STATE: NoticeItemVo = {
    content: null, 
    overview: null,
    publishDate: null,
    publisher: null,
    title: null,
};